import React, { useEffect, useMemo, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
// img
import logo from "../../../../../Assets/images/logo.png";
import { generatePath, Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Switch from "react-switch";
import PieChart from "components/Graph/PieChart";
import { useGetFeedbackStepDetailQuery, useSubmitFeedbackStepMutation } from "store/services/clients/assessmentTreatmentPlan";
import { Formik } from "formik";
import { CheckIcon, EditCricleIcon } from "Assets/icons";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { dateFormat, getAge, userFullName } from "helpers/common";
import { CLIENT_REPORT_TYPES, GOAL_TRACK_PARAMETERS, INDIVIDUAL_SESSION_REPORT_QUESTIONS, REPORT_IDS } from "config/constants";
import RenderQuestion, { RenderQuestionById } from "components/shared/ReportComponents/Questions/Index";
import SessionOutcomePieChart from "components/shared/ReportComponents/SessionOutcomePieChart";
import { formatReportFeedback, getGoalTrackingPercentage, reportInitialValues } from "helpers/assessment";
import AttachDocumentsReports from "components/shared/ReportComponents/AttachDocumentsReports";
import { array, date, object, string } from "yup";
import errorMessages from "utils/validation/errorMessages";
import LoadingButton from "components/shared/LoadingButton";
import { INDIVIDUAL_SESSION_REPORT, INDIVIDUAL_SESSION_REPORT_PREVIEW, INDIVIDUAL_START_SESSION, SCHOOL_CLIENT_LIST } from "config/paths";
import { reportQuestionsValidationSchema } from "utils/validation/validationHelpers";
import KhanReportLogo from "components/shared/ReportComponents/KhanReortLogo";
import GuardianDetailRow from "components/shared/ReportComponents/GuardianDetailRow";
import ReportHeader from "components/shared/ReportComponents/ReportHeader/Index";
import moment from "moment";
import ReportError from "../components/ReportError";

const IndividualSessionReport = () => {
  const navigate = useNavigate();
  const { assessmentId, clientId, clientType } = useParams();

  const [assessmentVirtualChecked, setAssessmentVirtualChecked] =
    useState(false);
  const [attendancePresentChecked, setAttendancePresentChecked] =
    useState(false);
  const [reportHeading, setReportHeading] = useState(CLIENT_REPORT_TYPES[REPORT_IDS.INDIVIDUAL_SESSION_REPORT].title);

  const [submitStep, { isLoading: submittingStep }] = useSubmitFeedbackStepMutation();
  const { data, isLoading, isFetching, isError, refetch } = useGetFeedbackStepDetailQuery({ assessmentId, clientId, clientType });
  const assessmentGoals = data?.assesmentData?.reportGoals;
  const assessmentAssignedId = data?.assesment?.id;
  const reportQuestions = data?.assesmentData?.reportQuestions;

  const caseDiscipline = data?.clientPendingCaseload?.clientCaseloadTherapist?.caseDiscipline;
  const caseTherapist = data?.clientPendingCaseload?.clientCaseloadTherapist?.clientCaseloadMapping?.find(x => x.caseTherapist?.therapist_detail?.type == "veteran")?.caseTherapist;
  const therapistDetails = { caseDiscipline, caseTherapist, discipline_id: data?.clientPendingCaseload?.clientCaseloadTherapist?.discipline_id }

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    setAssessmentVirtualChecked(data?.assesment?.assesment_location == "virtual");
  }, [data]);

  const initialValues = useMemo(() => {
    if (!data) return {};
    let answers = data?.assesmentData?.reportAnswers;
    let values = {
      documents: data?.assesmentData?.reportDocuments,
      resources: data?.assesmentData?.reportResources,
    };

    values = reportInitialValues(values, reportQuestions, answers);

    return values;
  }, [data]);

  const validationSchema = useMemo(() => {
    if (!reportQuestions) return object();

    return reportQuestionsValidationSchema(reportQuestions);
  }, [reportQuestions]);

  const handleChangeAssessmentLocation = (checked) => {
    setAssessmentVirtualChecked(checked);
  };

  const handleChangeAttendanceToggle = (checked) => {
    setAttendancePresentChecked(checked);
  };

  const handleSubmitStep = async (values) => {
    try {
      let payload = formatReportFeedback(reportHeading, reportQuestions, { ...values, assesment_location: assessmentVirtualChecked ? "virtual" : "in-person" });

      let response = await submitStep({
        assessmentAssignedId,
        data: payload,
        clientType
      }).unwrap();

      if (!response?.error) {
        navigate(generatePath(INDIVIDUAL_SESSION_REPORT_PREVIEW, {
          assessmentId,
          clientId,
          clientType,
        }));
      }

    } catch (err) {
      console.error("Error submitting step three", err);
    }
  };

  return (
    <>
      <section className="ReportSec py-3 position-relative">
        <Container fluid>
          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmitStep}
            validationSchema={validationSchema}
            enableReinitialize
          >
            {({ handleSubmit, values, errors }) => (
              <Form onSubmit={handleSubmit}>
                {console.log("values, errors >>>", values, errors)}
                <Row>
                  <Col lg="12" className="my-2">
                    <div className="cardCstm p-lg-5 rounded-2 bg-white shadow">
                      {isLoading ? (
                        <LoadingIndicator />
                      ) : isError ? (
                        <ErrorComponent />
                      ) : (
                        <>
                          {isFetching && <LoadingOverlay />}
                          <ReportHeader
                            initialHeading={data?.assesment?.report_heading || reportHeading}
                            therapistDetails={therapistDetails}
                            setHeading={setReportHeading}
                          />
                          <div className="formBody pt-3">
                            <div className="">
                              <div className="py-3">
                                <div
                                  className="cardCstm rounded-2 px-3"
                                  style={{ background: "#F9F9F9" }}
                                >
                                  <Row className="border-bottom p-2">
                                    <Col md="6" className="py-2">
                                      <div className="d-flex align-items-start gap-10 flex-wrap">
                                        <h6
                                          className="m-0 fw-sbold themeBlue"
                                          style={{ minWidth: 200, fontSize: 14 }}
                                        >
                                          Last Name
                                        </h6>
                                        <p className="m-0 themeBlue">
                                          {data?.lastname}
                                        </p>
                                      </div>
                                    </Col>
                                    <Col md="6" className="py-2">
                                      <div className="d-flex align-items-start gap-10 flex-wrap">
                                        <h6
                                          className="m-0 fw-sbold themeBlue"
                                          style={{ minWidth: 200, fontSize: 14 }}
                                        >
                                          First Name
                                        </h6>
                                        <p className="m-0 themeBlue">
                                          {data?.firstname}
                                        </p>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row className="border-bottom p-2">
                                    <Col md="6" className="py-2">
                                      <div className="d-flex align-items-start gap-10 flex-wrap">
                                        <h6
                                          className="m-0 fw-sbold themeBlue"
                                          style={{ minWidth: 200, fontSize: 14 }}
                                        >
                                          Date of Birth
                                        </h6>
                                        <p className="m-0 themeBlue">
                                          {dateFormat(data?.client_detail?.dob)}
                                        </p>
                                      </div>
                                    </Col>
                                    <Col md="6" className="py-2">
                                      <div className="d-flex align-items-start gap-10 flex-wrap">
                                        <h6
                                          className="m-0 fw-sbold themeBlue"
                                          style={{ minWidth: 200, fontSize: 14 }}
                                        >
                                          Age
                                        </h6>
                                        <p className="m-0 themeBlue">
                                          {getAge(data?.client_detail?.dob)}
                                        </p>
                                      </div>
                                    </Col>
                                  </Row>
                                  {clientType == "school" && <Row className="border-bottom p-2">
                                    <Col md="6" className="py-2">
                                      <div className="d-flex align-items-start gap-10 flex-wrap">
                                        <h6
                                          className="m-0 fw-sbold themeBlue"
                                          style={{ minWidth: 200, fontSize: 14 }}
                                        >
                                          Grade
                                        </h6>
                                        <p className="m-0 themeBlue">
                                          {data?.client_detail?.grade}
                                        </p>
                                      </div>
                                    </Col>
                                    <Col md="6" className="py-2">
                                      <div className="d-flex align-items-start gap-10 flex-wrap">
                                        <h6
                                          className="m-0 fw-sbold themeBlue"
                                          style={{ minWidth: 200, fontSize: 14 }}
                                        >
                                          School
                                        </h6>
                                        <p className="m-0 themeBlue">
                                          {data?.client_detail?.client_school_detail?.client_school?.name}
                                        </p>
                                      </div>
                                    </Col>
                                  </Row>}
                                  {/* Guardian Details */}
                                  {data?.client_detail?.client_guardian_mapping?.length > 0 &&
                                    data?.client_detail?.client_guardian_mapping?.map(
                                      (guardian, index) => {
                                        const slug = guardian?.client_guardian?.client_role?.slug;
                                        if (slug !== (clientType == "school" ? "teacher" : "parent")) {
                                          return null;
                                        }

                                        return (
                                          <GuardianDetailRow
                                            index={index}
                                            guardian={guardian}
                                            slug={slug}
                                          />
                                        );
                                      }
                                  )}
                                  <Row className="border-bottom p-2">
                                    <Col md="6" className="py-2">
                                      <div className="d-flex align-items-start gap-10 flex-wrap">
                                        <h6
                                          className="m-0 fw-sbold themeBlue"
                                          style={{ minWidth: 200, fontSize: 14 }}
                                        >
                                          Report Date
                                        </h6>
                                        <p className="m-0 themeBlue">
                                          {dateFormat(moment())}
                                        </p>
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row className="border-bottom p-2">
                                    <Col md="6" className="py-2">
                                      <div className=" d-flex align-items-center">
                                        <p className="m-0 text-muted mx-1">In-person</p>
                                        <Switch
                                          uncheckedIcon={""}
                                          checkedIcon={""}
                                          onHandleColor={"#A3DF00"}
                                          offHandleColor={"#A3DF00"}
                                          onColor={"#E6E6E6"}
                                          offColor={"#E6E6E6"}
                                          height={18}
                                          width={40}
                                          onChange={handleChangeAssessmentLocation}
                                          checked={assessmentVirtualChecked}
                                        />
                                        <p className="m-0 text-muted mx-1">Virtual</p>
                                      </div>
                                    </Col>
                                    {/* <Col md="6" className="py-2">
                                      <div className=" d-flex align-items-center">
                                        <p className="m-0 text-muted mx-1">Present</p>
                                        <Switch
                                          uncheckedIcon={""}
                                          checkedIcon={""}
                                          onHandleColor={"#A3DF00"}
                                          offHandleColor={"#A3DF00"}
                                          onColor={"#E6E6E6"}
                                          offColor={"#E6E6E6"}
                                          height={18}
                                          width={40}
                                          onChange={handleChangeAttendanceToggle}
                                          checked={attendancePresentChecked}
                                        />
                                        <p className="m-0 text-muted mx-1">Absent</p>
                                      </div>
                                    </Col> */}
                                  </Row>
                                </div>
                              </div>
                              {reportQuestions?.length > 0 &&
                                reportQuestions?.map((question, index) => {
                                  if (
                                    [
                                      INDIVIDUAL_SESSION_REPORT_QUESTIONS.greeting,
                                    ].includes(question.id)
                                  ) {
                                    return null;
                                  }

                                  return (
                                    <div className="py-3">
                                      <RenderQuestion
                                        key={index}
                                        question={question}
                                        fieldName={question.id}
                                      />
                                    </div>
                                  );
                                }
                                )}
                              {/* <div className="py-3">
                                <h6 className="m-0 fw-sbold themeBlue pb-1">
                                  Attendance
                                </h6>
                                <div className="border rounded-4">
                                  <Row>
                                    <Col className="py-3 col-6 border-end">
                                      <div className="text-center py-3 px-3">
                                        <h6
                                          className="m-0 d-flex align-items-start justify-content-center themeBlue fw-bold"
                                          style={{ fontSize: 13 }}
                                        >
                                          <span
                                            className="icn me-1"
                                            style={{ color: " rgb(61, 160, 170)" }}
                                          >
                                            ■{" "}
                                          </span>{" "}
                                          Absent <span className="themeClr">(33%)</span>
                                        </h6>
                                        <p className="m-0 pt-2">04/12 Sessions</p>
                                      </div>
                                    </Col>
                                    <Col className="py-3 col-6">
                                      <div className="text-center py-3 px-3">
                                        <h6
                                          className="m-0 d-flex align-items-start justify-content-center themeBlue fw-bold"
                                          style={{ fontSize: 13 }}
                                        >
                                          <span
                                            className="icn me-1"
                                            style={{ color: " rgb(61, 160, 170)" }}
                                          >
                                            ■{" "}
                                          </span>{" "}
                                          Present <span className="themeClr">(67%)</span>
                                        </h6>
                                        <p className="m-0 pt-2">08/12 Sessions</p>
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </div> */}
                              <div className="py-3">
                                <div className="py-3">
                                  <div
                                    className="cardCstm rounded-3 p-3"
                                    style={{ background: "#FBFBE6" }}
                                  >
                                    {assessmentGoals?.length > 0 &&
                                      assessmentGoals?.map((goal, index) => (
                                        <Row>
                                          <Col md="7" className="my-2">
                                            <div className="top d-flex align-items-start">
                                              <h5 className="m-0 fw-bold themeBlue">
                                                {index + 1}.
                                              </h5>
                                              <div className="px-3">
                                                <h5 className="m-0 pb-1 fw-sbold themeBlue border-bottom">
                                                  Area
                                                </h5>
                                                <p className="m-0 themeBlue pt-1">
                                                  {goal?.assesmentGoalDisciplineArea?.name}
                                                </p>
                                              </div>
                                              <div className="px-3">
                                                <h5 className="m-0 pb-1 fw-sbold themeBlue border-bottom">
                                                  Goal
                                                </h5>
                                                <p className="m-0 themeBlue pt-1">
                                                  {goal?.assesmentGoalDetail?.title}
                                                </p>
                                              </div>
                                              <div className="px-3">
                                                <h5 className="m-0 pb-1 fw-sbold themeBlue border-bottom">
                                                  Context
                                                </h5>
                                                <p className="m-0 themeBlue pt-1">
                                                  {goal?.assesmentGoalContext?.context}
                                                </p>
                                              </div>
                                            </div>
                                            <div className="bottom pt-4">
                                              <h5 className="m-0 fw-bold themeBlue mb-3">
                                                Goal Details
                                              </h5>
                                              <div
                                                className="px-lg-4 p-3 rounded-3"
                                                style={{ background: "#F2F3DA" }}
                                              >
                                                <p className="m-0 themeBlue">
                                                  {goal?.goal_description}
                                                </p>
                                              </div>
                                            </div>
                                            <div className="bottom pt-4">
                                              <h5 className="m-0 fw-bold themeBlue mb-3">
                                                Goal Review
                                              </h5>
                                              <div
                                                className="px-lg-4 p-3 rounded-3"
                                                style={{ background: "#F2F3DA" }}
                                              >
                                                <p className="m-0 themeBlue">
                                                  {goal?.goal_notes}
                                                </p>
                                              </div>
                                            </div>
                                          </Col>
                                          <Col md="5" className="my-2">
                                            <div
                                              className="innerCard p-3 rounded-4"
                                              style={{ background: "#E8F2E0" }}
                                            >
                                              <div className="px-lg-4">
                                                <div className="py-2">
                                                  <SessionOutcomePieChart
                                                    trackingData={
                                                      goal?.goalTracking
                                                    }
                                                  />
                                                </div>
                                                {goal?.goalTracking
                                                  ?.length > 0 ? (
                                                  <ul className="list-unstyled ps-0 mb-0">
                                                    {Object.entries(
                                                      GOAL_TRACK_PARAMETERS
                                                    )?.map(
                                                      (
                                                        [param, label],
                                                        index
                                                      ) => {
                                                        let parameterPercentage =
                                                          getGoalTrackingPercentage(
                                                            param,
                                                            goal?.goalTracking
                                                          );
                                                        return (
                                                          <li
                                                            key={index}
                                                            className="py-1 d-flex align-items-center justify-content-between gap-10"
                                                          >
                                                            <p className="m-0">
                                                              <span className="fw-sbold">
                                                                {param}
                                                              </span>{" "}
                                                              -{label}
                                                            </p>
                                                            <p className="m-0 fw-bold">
                                                              <span className="px-2">
                                                                {
                                                                  parameterPercentage
                                                                }
                                                              </span>
                                                              %
                                                            </p>
                                                          </li>
                                                        );
                                                      }
                                                    )}
                                                  </ul>
                                                ) : (
                                                  <p>
                                                    Goal not tracked yet
                                                  </p>
                                                )}
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                      ))
                                    }
                                  </div>
                                </div>
                              </div>
                              <div className="py-3">
                                <RenderQuestionById
                                  questionId={INDIVIDUAL_SESSION_REPORT_QUESTIONS.greeting}
                                  reportQuestions={reportQuestions}
                                  showQuestion={false}
                                />
                              </div>
                              <div className="py-3">
                                <AttachDocumentsReports
                                  acl={"private"}
                                  name="documents"
                                  allowedTypes={["pdf", "doc", "docx", "jpg", "xlsx", "png"]}
                                />
                              </div>
                            </div>
                            <div className="py-3">
                              <img
                                src={
                                  therapistDetails?.caseTherapist
                                    ?.therapist_detail?.signature_img
                                }
                                style={{ height: 70 }}
                                alt=""
                                className="img-fluid object-fit-contain"
                              />
                              <p className="m-0 fw-sbold" style={{ whiteSpace: "pre-wrap" }}>
                                {therapistDetails?.caseTherapist?.therapist_detail?.email_signature}
                              </p>
                            </div>
                            <div className="py-3">
                              <KhanReportLogo />
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </Col>
                  <Col lg="12" className="my-2">
                    <ReportError />
                    <div className="d-flex align-items-center gap-10">
                      <Button
                        style={{ background: "#45a3a5", borderColor: "#45a3a5" }}
                        onClick={() =>
                          navigate(generatePath(INDIVIDUAL_START_SESSION, {
                            assessmentId,
                            clientId,
                            clientType
                          }))
                        }
                        disabled={!!submittingStep}
                        className="d-flex align-items-center justify-content-center commonBtn"
                      >
                        Back
                      </Button>
                      <LoadingButton
                        type="submit"
                        className="d-flex align-items-center justify-content-center commonBtn"
                        isLoading={submittingStep}
                      >
                        Save & Preview
                      </LoadingButton>
                    </div>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Container>
      </section>
    </>
  );
};

export default IndividualSessionReport;
